export const tasksType = [
  {
    label: 'DIY',
    value: 'diy',
  },
  {
    label: 'Cliente',
    value: 'client',
  },
]
